// Shim for react-native-config
// process.env.* values are injected statically by dotenv-webpack at build time
const Config = {
  API_URL: process.env.API_URL || '',
  WS_URL: process.env.WS_URL || '',
  ENVIRONMENT: process.env.ENVIRONMENT || 'development',
  APP_NAME: process.env.APP_NAME || '',
  APP_DEBUG_MODE: process.env.APP_DEBUG_MODE || 'false',
  BUILD_TYPE: process.env.BUILD_TYPE || 'debug',
  PACKAGE_NAME: process.env.PACKAGE_NAME || '',
  BUNDLE_ID: process.env.BUNDLE_ID || '',
  SB_APP_ID: process.env.SB_APP_ID || '',
  SENTRY_ENABLED: process.env.SENTRY_ENABLED || 'false',
  SENTRY_DSN: process.env.SENTRY_DSN || '',
  CLARITY_ENABLED: process.env.CLARITY_ENABLED || 'false',
  CLARITY_PROJECT_ID: process.env.CLARITY_PROJECT_ID || '',
  SUPPORT_PHONE_NUMBER: process.env.SUPPORT_PHONE_NUMBER || '',
  // Kinde — callback URLs are overridden to web URLs by webpack DefinePlugin
  KINDE_ISSUER_URL: process.env.KINDE_ISSUER_URL || '',
  KINDE_CLIENT_ID: process.env.KINDE_CLIENT_ID || '',
  KINDE_POST_CALLBACK_URL: process.env.KINDE_POST_CALLBACK_URL || '',
  KINDE_POST_LOGOUT_REDIRECT_URL: process.env.KINDE_POST_LOGOUT_REDIRECT_URL || '',
};

export default Config;
